'use client';

import React from 'react';
import { GetInTouchSection } from '@/components/ui/sections/GetInTouch';
import { ServiceAreasSection } from '@/components/ui/sections/ServiceAreas';
import { SERVICE_AREAS } from '@/components/ui/sections/ServiceAreas/consts';
import SectionBase from '@/components/ui/sections/section-base';
import SectionHeader from '@/components/ui/sections/section-header';
import { SERVICE_AREA_DATA_MAP } from './data';
import { ServiceAreasStructuredData } from './ui/StructuredData';
import { ServiceAreasStorySection } from './ui/Story';
import { TownLinks } from './ui/TownLinks';
import { ServiceAreasFAQSection } from './ui/FAQ';

export default function Page() {
  const towns = Object.values(SERVICE_AREA_DATA_MAP);

  return (
    <>
      <ServiceAreasStructuredData />

      <SectionBase id="hero" background="bg-background">
        <SectionHeader
          subtitle="OUR SERVICE AREAS"
          title="Custom Home Builder Serving Northeastern Oklahoma"
          description="Cornerstone Homes & Properties designs, builds, and renovates homes across Claremore, Tulsa, Broken Arrow, Owasso, Catoosa, Verdigris, Inola, and the greater Rogers County area."
        />
      </SectionBase>

      <ServiceAreasStorySection />

      <ServiceAreasSection
        serviceAreas={SERVICE_AREAS}
        showCTA={false}
        showHeader={false}
        groupAreas
      />

      <TownLinks towns={towns} />

      <ServiceAreasFAQSection />

      <GetInTouchSection />
    </>
  );
}
